import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type CrmId = string;
type Title = string;
type Description = string;
type DailyLimit = string;

export interface Owner {
    id: number;
    name: string;
    email: string;
}

// ----------------------- actions -------------------------------------
const SET_CRM_ACTIVITY_ID = 'SET_CRM_ACTIVITY_ID';
const SET_CRM_ACTIVITY_TITLE = 'SET_CRM_ACTIVITY_TITLE';
const SET_CRM_ACTIVITY_DESCRIPTION = 'SET_CRM_ACTIVITY_DESCRIPTION';
const SET_CRM_ACTIVITY_LIMIT = 'SET_CRM_ACTIVITY_LIMIT';
const SET_CRM_ACTIVITY_OWNERS = 'SET_CRM_ACTIVITY_OWNERS';
const SET_CRM_ACTIVITY_LIST_OWNERS = 'SET_CRM_ACTIVITY_LIST_OWNERS';

interface PayloadTypes {
    [SET_CRM_ACTIVITY_ID]: CrmId;
    [SET_CRM_ACTIVITY_TITLE]: Title;
    [SET_CRM_ACTIVITY_DESCRIPTION]: Description;
    [SET_CRM_ACTIVITY_LIMIT]: DailyLimit;
    [SET_CRM_ACTIVITY_OWNERS]: Owner[];
    [SET_CRM_ACTIVITY_LIST_OWNERS]: Owner[];
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setCrmId = ActionCreator(SET_CRM_ACTIVITY_ID);
export const setCrmActivityTitle = ActionCreator(SET_CRM_ACTIVITY_TITLE);
export const setCrmActivityDescription = ActionCreator(SET_CRM_ACTIVITY_DESCRIPTION);
export const setCrmActivityLimit = ActionCreator(SET_CRM_ACTIVITY_LIMIT);
export const setCrmActivityOwners = ActionCreator(SET_CRM_ACTIVITY_OWNERS);
export const setCrmActivityListOwners = ActionCreator(SET_CRM_ACTIVITY_LIST_OWNERS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
export interface CrmActivityState {
    crmId: CrmId;
    title: Title;
    description: Description;
    dailyLimit: DailyLimit;
    owners: Owner[];
    listOwners: Owner[];
}

export const CRM_ACTIVITY_INITIAL_STATE: CrmActivityState = {
    crmId: '',
    title: '',
    description: '',
    dailyLimit: '',
    owners: [],
    listOwners: [],
};

export default createReducer<CrmActivityState, PayloadTypes>(CRM_ACTIVITY_INITIAL_STATE, {
    [SET_CRM_ACTIVITY_TITLE]: (state, { payload }) => ({
        ...state,
        title: payload,
    }),
    [SET_CRM_ACTIVITY_OWNERS]: (state, { payload }) => ({
        ...state,
        owners: payload,
    }),
    [SET_CRM_ACTIVITY_LIST_OWNERS]: (state, { payload }) => ({
        ...state,
        listOwners: payload,
    }),
    [SET_CRM_ACTIVITY_DESCRIPTION]: (state, { payload }) => ({
        ...state,
        description: payload,
    }),
    [SET_CRM_ACTIVITY_LIMIT]: (state, { payload }) => ({
        ...state,
        dailyLimit: payload,
    }),
    [SET_CRM_ACTIVITY_ID]: (state, { payload }) => ({
        ...state,
        crmId: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
